import { buildRecordFromKeyList } from "../build-record-from-key-list";
import { NEW_STREET_LIGHT_TYPE_KEY_LIST, OLD_STREET_LIGHT_TYPE_KEY_LIST, STREET_LIGHT_TYPE_KEY_LIST, } from "./street-light-type";
export const EMPTY_STREET_LIGHTING_CONVERSION_PARAMETERS = {
    stockCountByType: buildRecordFromKeyList(STREET_LIGHT_TYPE_KEY_LIST, () => 0),
    replacementCountByOldType: buildRecordFromKeyList(OLD_STREET_LIGHT_TYPE_KEY_LIST, () => buildRecordFromKeyList(NEW_STREET_LIGHT_TYPE_KEY_LIST, () => 0)),
};
